import {Typography} from '@material-ui/core'
import * as React from 'react'

type HeaderProps = {
    text: string
}

export class Header extends React.Component<HeaderProps> {
    public render = () => (<Typography variant="h3" gutterBottom display="inline">{this.props.text}</Typography>)
}